import { ago, daysBetween } from './format';
/** Fälligkeits-Karte für Filter/Robi (Toggle "heute erledigt"). */
export function careCard(type, everyDays, verb, care, t) {
    const list = care.filter(c => c.type === type).sort((a, b) => (a.date < b.date ? -1 : 1));
    const last = list[list.length - 1];
    const on = care.some(c => c.type === type && c.date === t);
    const sw = {
        on,
        switchBg: on ? 'var(--primary)' : 'var(--toggle-off)',
        knobLeft: on ? '21px' : '3px'
    };
    if (!last) {
        return { headline: 'Noch nie', sub: 'Umschalten zum Eintragen', color: 'var(--never-color)', ...sw };
    }
    const days = daysBetween(t, last.date);
    const over = days > everyDays;
    return {
        headline: days === 0 ? 'Heute' : days === 1 ? 'Gestern' : `vor ${days} Tagen`,
        sub: over ? `${verb} fällig` : `nächste in ${everyDays - days} Tagen`,
        color: over ? 'var(--due-color)' : 'var(--ok-color)',
        ...sw
    };
}
/** Bestehende Tagesnotiz (Typ "note") für ein Datum, falls vorhanden. */
export function noteEntryFor(care, date) {
    return care.find(c => c.type === 'note' && c.date === date) ?? null;
}
/** Fälligkeits-Hinweiszeile für die Alkalinitäts-Karte. */
export function alkalinityNote(lastDate, taDays, t) {
    if (lastDate === null) {
        return { note: `Noch nie gemessen · alle ${Math.round(taDays)} Tage`, due: true, color: 'var(--due-color)' };
    }
    const daysAgo = daysBetween(t, lastDate);
    const due = daysAgo >= taDays;
    return {
        note: due ? `Messung fällig · zuletzt ${ago(lastDate, t)}` : `nächste Messung in ${Math.round(taDays) - daysAgo} Tagen`,
        due,
        color: due ? 'var(--due-color)' : 'var(--text-secondary)'
    };
}
